import { post } from '@/utils/request'

export interface LoginParams {
  phone: string
  code: string
}

export interface LoginResult {
  token: string
  id: number
  phone: string
  user_name: string
}

export function login(data: LoginParams) {
  return post<LoginResult>('/admin/login/phone', data)
}

export function sendSmsCode(phone: string) {
  return post<void>('/admin/sms/send', { phone })
}

export function logout() {
  return post<void>('/admin/logout')
}
